import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() =>
  createStyles({
    card: {
      width: '48rem',
      minHeight: '28rem',
      display: 'flex',
    },
    cardContent: {
      width: '100%',
    },
  }),
)
